import css from './LaborAndToolsItemsTypesHeaderStep2.module.css';
import React, { useState } from 'react';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { FragmentInfoMobileDropdown } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/FragmentInfoMobileDropdown/FragmentInfoMobileDropdown';

interface LaborAndToolsItemsTypesHeaderProps {
    title?: string;
    description?: string;
    expanded?: boolean;
    toggleExpand: () => void;
}

export const LaborAndToolsItemsTypesHeaderStep2: React.FC<
    LaborAndToolsItemsTypesHeaderProps
> = ({ title, description, expanded, toggleExpand }) => {
    const [isDesktop] = useMediaType();

    return isDesktop ? (
        <div className={css.fragmentInfo}>
            <div className={css.fragmentInfoTitleContainer}>
                <div className={css.fragmentInfoTitle}>{title}</div>
                <div className={css.fragmentInfoDescription}>{description}</div>
            </div>
        </div>
    ) : (
        <FragmentInfoMobileDropdown
            isLaborAndTools={true}
            isExpanded={expanded}
            toggleExpand={toggleExpand}
            fragmentTitle={title}
            description={description}
        />
    );
};
